// Auto-import SASS generated CSS
import './index.css';

export type {
  CheckboxDropdownProps,
  CheckboxDropdownOption,
} from './CheckboxDropdown';
export {default as default} from './CheckboxDropdown';
